<template>
  <div class="timeline-subtitle">
    <div class="timeline-subtitle-button">
      <div class="add-subtitle" @click="addSubtitle">插入字幕</div>
      <div class="play-subtitle" @click.stop="preview" @mousedown.stop>
        <i :class="isPlay ? 'pause': 'play'"></i>
      </div>
      <div class="play-time-show">
        <div class="now-time">{{nowTime | formatTime}}</div>
        <span>/</span>
        <div class="total-time">{{totalTime | formatTime}}</div>
      </div>
    </div>
    <div class="timeline-subtitle-content">
      <div class="timeline-body" v-dragSubtitle ref="timelineBody" @scroll="scrollEvent">
        <div class="slider-timeline" :style="{left: (nowTime-0.1)*secondWidth + 10 + 'px'}">
          <div class="slider-handle" data-action="handle"></div>
          <div class="slider-line"></div>
        </div>
        <div class="axis-timeline" :style="axisStyle">
          <div class="axis-first"></div>
          <div class="axis-second" v-for="n in totalTimeInt">
            <div class="second-time" :class="{'time-over-color': n-1>totalTime}">{{n-1 + 's'}}</div>
            <div class="second-line">
              <div v-for="i in 9" :class="{'middle-line': i === 5}"></div>
            </div>
          </div>
          <div class="axis-last" :class="{'time-over-color': totalTimeInt>totalTime}">
            <span>{{totalTimeInt + 's'}}</span>
          </div>
        </div>
        <div class="axis-timeline-mask" :style="axisStyle" data-action="ruler"></div>
        <div
          class="axis-timeover-mask"
          :style="{
            width: (totalTimeInt - totalTime) * secondWidth + 2 + 'px',
            left: totalTime*secondWidth + 11 + 'px'
          }"
        ></div>
        <div class="subtitle-box" :style="{width: totalWidth + 'px'}">
          <div class="total-time-width" data-action="ruler" :style="{width: totalTime * secondWidth + 'px'}"></div>
          <div
            v-if="scenesTime.length"
            class="scenes-time-line"
            v-for="(s,j) in scenesTime"
            :style="{left: secondWidth*s + 'px'}"
          ></div>
          <div
            class="subtitle-box-content"
            :class="{active: i===subIndex}"
            v-for="(s, i) in subtitles"
            :style="{
              left:secondWidth*s.start + 'px',
              width: secondWidth*s.dura + 'px'
            }"
          >
            <div class="drag-left" data-action="left" :data-index="i"></div>
            <div class="drag-right" data-action="right" :data-index="i"></div>
            <div class="subtitle-move" data-action="move" :data-index="i">{{s.text}}</div>
          </div>
        </div>
      </div>
      <div class="scroll-left-line" v-dragSubtitle v-show="scrollWidth > visibleWidth">
        <div class="scroll-left-handle" :style="handleXStyle" data-action="scroll"></div>
      </div>
      <div class="timeline-body-title">字幕</div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      type: "editor",
      totalTime: 30, //总时间
      totalTimeInt: 0, // 应该显示的总时间
      secondWidth: 100, // 每一秒的宽度
      nowTime: 0, // 指针的时间
      totalWidth: 0, // 字幕轴的总长度
      mpos: {
        // 鼠标点击的临时计算使用数据（里面包含很多初始化的信息）
        x: 0,
        nowTime: 0
      },
      action: "", // 鼠标点击的动作
      visibleWidth: 0, // 滚动元素可见的宽度
      scrollWidth: 0, // 滚动元素里面的总高度
      scrollLeft: 0, // 滚动值
      limitLeft: 0, // 滚动元素的左边位置
      limitRight: 0, // 滚动元素的右边位置
      limitTimeMove: false, // 是否处于在拖动时间光标时发生的滚动循环事件
      limitTimeFrame: null, // 接收时间光标滚动事件的对象，cancelAnimationFrame
      subtitles: [], // 简化后的字幕数组，用于显示操作字幕（在完成操作后应用到字幕数组）
      indexS: -1, // 选中的简化字幕数组的index值
      limitSubtitleMove: false, // 字幕拖动发生的滚动循环事件
      limitSubtitleFrame: null, // 接收字幕拖动的滚动事件的对象，cancelAnimationFrame
      handleXWidth: 0, // 自定义滚动条的宽度
      handleXLeft: 0, // 自定义滚动条的定位
      isPlay: false, // 是否处于播放中
      oldFrame: 0,
      playFrame: null, // 播放事件的循环时间对象，cancelAnimationFrame,
      scenesTime: [], // 场景页时间分割点
      timeNode: [0] // 每个scenes的时间节点数组
    };
  },
  computed: {
    ...mapGetters({
      editor: "TOOL",
      subIndex: "subtitle/subIndex", // 选中的字幕数组的index
      subtitleArr: "subtitle/subtitles", // 字幕数组
      subtitleObj: "subtitle/subtitleObj" // 字幕数组
    }),
    axisStyle() {
      // 尺子的宽度（等）
      const style = {};
      style.width = this.scrollWidth + "px";
      return style;
    },
    handleXStyle() {
      // 滚动条样式
      const style = {};
      style.width = this.handleXWidth + "px";
      style.left = this.handleXLeft + "px";
      return style;
    }
  },
  watch: {
    nowTime() {
      if (this.type === "editor") {
        let data = this.calcFrame();
        if (!data) return;
        if(!this.isPlay) {
          this.editor.player.maskEle.children().hide();
        } else {
          if (data.frame - this.oldFrame < 0) {
            this.$bus.emit("switch_scenes_play", {
              time: this.nowTime * 1000,
              id: data.id
            });
          }
          this.oldFrame = data.frame;
        }
        this.editor.eve.emit("playByFrame", data.frame, data.id);
        this.editor.eve.emit("play_" + data.id, data.frame);
      }

      this.$bus.emit("playSubtitleTime", {frame: Math.ceil(this.nowTime * 60)})
    },
    'subtitleObj.duration': function() {
      if(this.subtitleObj.duration) {
        this.nowTime = 0;
        this.totalTime = this.subtitleObj.duration;
        this.initStyle();
      }
    }
  },
  mounted() {
    this.initData();

    this.$bus.on("pickUpSubtitle", data => {
      let subtitles = [];
      if (data && data.length) {
        let sT = 0;
        let mT = this.totalTime;
        let subs = [];
        let sub = null;
        let str = JSON.stringify(this.subtitleArr);
        this.$store.commit("subtitle/clearSubtitles");
        data.forEach(info => {
          if(info.index < 0) {
            sT = 0;
            mT = this.totalTime;
          } else {
            sT = this.timeNode[info.index] || 0;
            mT = this.timeNode[info.index+1] || this.totalTime;
          }
          subs = info.data;
          for(let i in subs) {
            sub = {
              startTime: subs[i].bg / 1000 + sT,
              endTime: subs[i].ed / 1000 + sT,
              text: subs[i].onebest
            }
            if(sub.endTime > mT || sub.startTime > mT) {
              break;
            }
            subtitles.push(sub)
          }
        });
        this.$store.commit("subtitle/addGroupSubtitles", {
          subtitles: subtitles
        });
        this.$bus.emit("insert_subtitle_undo", {
          type: "swapSubtitles_time",
          data: {
            reData: str,
            data: JSON.stringify(this.subtitleArr)
          }
        });
        this.calcSubtitles();
        // 添加完成后是否显示的问题（时间不会跳转）
        this.$bus.emit("playSubtitleTime", {frame: Math.ceil(this.nowTime * 60)})
      }
    });

    this.$bus.on("subtitle_undoRodo_execute", ({mod, type}) => {
      if(mod === "updateSubtitle_time" ||
         mod === "addSubtitles_time" ||
         mod === "swapSubtitles_time" ||
         mod === "delSubtitles") {
        this.calcSubtitles()
        if(this.subIndex > -1) {
          this.nowTime = this.subtitles[this.subIndex].start
        } else {
          this.$bus.emit("playSubtitleTime", {frame: Math.ceil(this.nowTime * 60)})
        }
      }
    })

    this.$bus.on("subtitle_keycode_space", () => {
      this.preview();
    })
    this.$bus.on("subtitle_keycode_del", () => {
      this.calcSubtitles()
    })
    this.$bus.on("subtitle_panel_del", () => {
      this.calcSubtitles()
    })
    this.$bus.on("subtitle_fromJson", () => {
      this.totalTime = this.subtitleObj.duration;
      this.initData();
    })
    this.$bus.on("subtitle_updateItemText_vue", () => {
      this.subtitles[this.subIndex].text = this.subtitleArr[this.subIndex].text
    })

    window.addEventListener("mousedown", this.stopPlay, false);
    window.addEventListener("resize", this.initStyle, false);
  },
  methods: {
    initData() {
      let totalTime = 0;
      this.scenesTime = [];
      this.nowTime = 0;
      if (!this.$route.subtitle) {
        this.type = "editor";
        this.getTimeNode();
      } else {
        this.type = "video";
      }
      this.totalTimeInt = Math.ceil(this.totalTime);
      this.calcSubtitles();
      this.initStyle();
    },
    calcSubtitles() {
      // 处理数组为简易数组
      let part = null;
      let sub = null;
      this.subtitles = [];
      for (let i in this.subtitleArr) {
        sub = this.subtitleArr[i];
        part = {
          start: sub.startTime,
          end: sub.endTime
        };
        part.dura = part.end - part.start;
        part.text = sub.text;

        if(part.end > this.totalTime) {
          // 字幕大于时间的时候（删除字幕或者截取）
          let j = +i;
          if(this.totalTime - part.start >= 0.2) {
            part.end = this.totalTime;
            part.dura = part.end - part.start;
            this.$store.commit("subtitle/updateSubtitle", {index: i, subtitle: {
              startTime: part.time,
              endTime: part.end
            }});
            this.subtitles.push(part);
            j++
          }
          while (this.subtitleArr && this.subtitleArr.length > j) {
            this.$store.commit("subtitle/delSubtitles", j);
          }
          return;
        }
        this.subtitles.push(part);
      }
    },
    initStyle() {
      // 初始化样式数据和计算所用数据
      let tt = Math.ceil(this.totalTime);
      let timeline = document.body.clientWidth - 246;
      let vw = timeline * 0.9;
      if (vw < tt * this.secondWidth) {
        this.totalTimeInt = tt;
      } else {
        this.totalTimeInt = Math.floor(vw / this.secondWidth);
      }

      // getBoundingClientRect 会受到window.scrollX的影响，故使用直接计算
      this.totalWidth = this.secondWidth * this.totalTimeInt;
      this.limitLeft = timeline * 0.07;
      this.limitRight = timeline * 0.97;
      this.visibleWidth = vw;
      this.scrollWidth = this.totalWidth + 20;
      this.$nextTick(() => {
        // ({left: this.limitLeft, right: this.limitRight, width: this.visibleWidth} = this.$refs.timelineBody.getBoundingClientRect())
        this.scrollLeft = this.$refs.timelineBody.scrollLeft;
        this.handleXWidth =
          (this.visibleWidth * (this.visibleWidth - 20)) / this.scrollWidth;
        this.handleXLeft =
          (this.scrollLeft * (this.visibleWidth - 20)) / this.scrollWidth;
      });
    },
    getTimeNode() {
      let totalTime = 0;
      // 获取每个scenes组的开始和结束时间，并将scenes初始到第0帧
      if (this.editor && this.editor.sprites) {
        for (let i = 0; i < this.editor.sprites.length; i++) {
          let scene = this.editor.sprites[i];
          // eve('playByFrame', null, 0, scene.id)
          this.editor.eve.emit("playByFrame", 0, scene.id);
          this.editor.eve.emit("play_" + scene.id, 0);
          this.editor.player.scenesDict[scene.id].ele.hide();
          totalTime += scene.duration / 1000;
          this.timeNode[i + 1] = totalTime;
          this.scenesTime.push(totalTime);
        }
        this.totalTime = totalTime;
        this.scenesTime.pop();
        this.editor.player.maskEle.children().hide();
        this.editor.cancelPlay();
        // eve('playByFrame', null, 1, this.editor.sprites[0].id)
        this.editor.eve.emit("playByFrame", 0, this.editor.sprites[0].id);
        this.editor.eve.emit("play_" + this.editor.sprites[0].id, 0);
      }
    },
    calcFrame() {
      // 计算播放到哪个scenes的帧数
      if (this.timeNode.length) {
        let data = {};
        for (let i = 0; i < this.timeNode.length - 1; i++) {
          if (
            this.nowTime >= this.timeNode[i] &&
            this.nowTime <= this.timeNode[i + 1]
          ) {
            data.frame = Math.ceil((this.nowTime - this.timeNode[i]) * 60);
            data.id = this.editor.sprites[i].id;
            return data;
          }
        }
      }
    },
    initScencePlay() {
      // 将当前播放的scenes后面的scenes初始化第0帧
      if (this.type !== "editor") return;
      let isInit = false,
        nowId = "",
        frame = 0;
      for (let i = 0; i < this.timeNode.length - 1; i++) {
        if (isInit && this.editor.sprites[i]) {
          this.editor.eve.emit("playByFrame", 0, this.editor.sprites[i].id);
          this.editor.player.scenesDict[this.editor.sprites[i].id].ele.hide();
          this.editor.sprites[i].effect.reset();
        }
        if (
          this.nowTime >= this.timeNode[i] &&
          this.nowTime <= this.timeNode[i + 1]
        ) {
          isInit = true;
          nowId = this.editor.sprites[i].id;
          frame = Math.ceil(((this.nowTime - this.timeNode[i])) * 60);
          this.editor.sprites[i].effect.reset();
        }
      }
      this.editor.player.maskEle.children().hide();
      this.editor.eve.emit("playByFrame", frame, nowId);
      this.editor.eve.emit("play_" + nowId, frame);
      this.$bus.emit("timeline_play_all", {
        isPlay: this.isPlay,
        time: this.nowTime
      });
    },
    mouseDown(dataset, disx, e) {
      let m = null;
      this.mpos.x = disx;
      this.mpos.nowTime = this.nowTime;
      this.action = dataset.action;
      this.indexS = -1;
      if (this.action === "handle") {
        // 时间光标
      } else if (this.action === "ruler") {
        // 刻度尺
        let dt =
          (this.$refs.timelineBody.scrollLeft + disx - 10 - this.limitLeft) /
          this.secondWidth;
        this.nowTime = dt < 0 ? 0 : dt > this.totalTime ? this.totalTime : dt;
      } else if (this.action === "move") {
        // 字幕拖动(获取极限值)
        this.indexS = +dataset.index;
        m = this.subtitles[this.indexS];
        if (this.subtitles[this.indexS - 1]) {
          this.mpos.ml = this.subtitles[this.indexS - 1].end;
        } else {
          this.mpos.ml = 0;
        }
        if (this.subtitles[this.indexS + 1]) {
          this.mpos.mr = this.subtitles[this.indexS + 1].start;
        } else {
          this.mpos.mr = this.totalTime;
        }
      } else if (this.action === "left") {
        this.indexS = +dataset.index;
        m = this.subtitles[this.indexS];
        if (this.subtitles[this.indexS - 1]) {
          this.mpos.ml = this.subtitles[this.indexS - 1].end;
        } else {
          this.mpos.ml = 0;
        }
        this.mpos.mr = m.end - 0.2;
      } else if (this.action === "right") {
        this.indexS = +dataset.index;
        m = this.subtitles[this.indexS];
        if (this.subtitles[this.indexS + 1]) {
          this.mpos.mr = this.subtitles[this.indexS + 1].start;
        } else {
          this.mpos.mr = this.totalTime;
        }
        this.mpos.ml = m.start + 0.2;
      } else if (this.action === "scroll") {
        // 滚动条
        e.stopPropagation();
        this.mpos.scroll = this.scrollLeft;
        this.mpos.handleXLeft = this.handleXLeft;
      }

      if (m) {
        // 对于字幕操作的共同部分
        this.$store.commit("subtitle/setSubIndex", this.indexS);
        this.mpos.l = m.start;
        this.mpos.r = m.end;
        this.mpos.d = m.dura;
        this.mpos.scroll = this.$refs.timelineBody.scrollLeft;
        this.mpos.dx =
          (disx + this.mpos.scroll - this.limitLeft - 10) / this.secondWidth -
          this.mpos.l;
        this.nowTime = m.start;
      } else {
        this.$store.commit("subtitle/setSubIndex", -1);
      }
    },
    mouseMove(disx) {
      if (this.action === "handle") {
        if (disx >= this.limitRight) {
          // 鼠标超过又极限（滚动事件开始触发）
          this.limitTime(1);
        } else if (disx <= this.limitLeft) {
          this.limitTime(-1);
        } else {
          // 回到正常模式下先关闭滚动的循环事件
          this.cancelLimitTime(disx);
          let dt = (disx - this.mpos.x) / this.secondWidth + this.mpos.nowTime;
          this.nowTime = dt < 0 ? 0 : dt > this.totalTime ? this.totalTime : dt;
        }
      } else if (this.indexS >= 0) {
        let change = 0,
          cl = this.mpos.l,
          cr = this.mpos.r;

        if (disx >= this.limitRight) {
          this.limitSubtitle(1, this.mpos);
        } else if (disx <= this.limitLeft) {
          this.limitSubtitle(-1, this.mpos);
        } else {
          this.cancellimitSubtitle(disx);
          change = (disx - this.mpos.x) / this.secondWidth;
          cl = this.mpos.l + change;
          cr = this.mpos.r + change;
          this.mpos.change = change;
          this.subtitleBoxChange(cl, cr);
        }
      } else if (this.action === "scroll") {
        let ds = this.mpos.handleXLeft - this.mpos.x + disx;
        if (ds < 0) {
          ds = 0;
        } else if (ds > this.visibleWidth - 20 - this.handleXWidth) {
          ds = this.visibleWidth - 20 - this.handleXWidth;
        }
        this.handleXLeft = ds;
        this.$refs.timelineBody.scrollLeft =
          (ds / (this.visibleWidth - 20)) * this.scrollWidth;
      }
    },
    mouseUp(disx) {
      if (this.action === "handle") {
        this.cancelLimitTime();
      } else if (
        this.action === "move" ||
        this.action === "left" ||
        this.action === "right"
      ) {
        this.cancellimitSubtitle();
        if (this.mpos.change) {
          let subtitle = {
            startTime: +this.subtitles[this.indexS].start.toFixed(3),
            endTime: +this.subtitles[this.indexS].end.toFixed(3)
          };
          this.$bus.emit("insert_subtitle_undo", {
            type: "updateSubtitle_time",
            data: {
              index: this.indexS,
              reData: {
                startTime: this.subtitleArr[this.indexS].startTime,
                endTime: this.subtitleArr[this.indexS].endTime
              },
              data: subtitle
            }
          });
          this.$store.commit("subtitle/updateSubtitle", { subtitle });
          this.nowTime = subtitle.startTime;
        }
      }
      if(this.mpos.nowTime !== this.nowTime) {
        this.initScencePlay()
      }
      this.mpos = {};
      this.action = "";
    },
    subtitleBoxChange(cl, cr) {
      // 接受cl(start开始时间：变化后)  cr(end结束时间：变化后) 判断极限 判断吸附 判断光标
      let stop = false;
      if (this.action === "move") {
        for (let i in this.scenesTime) {
          if (Math.abs(cl - this.scenesTime[i]) < 0.1) {
            cl = this.scenesTime[i];
            cr = cl + this.mpos.d;
            break;
          }

          if (Math.abs(cr - this.scenesTime[i]) < 0.1) {
            cr = this.scenesTime[i];
            cl = cr - this.mpos.d;
            break;
          }
        }
        if (cl < this.mpos.ml) {
          cl = this.mpos.ml;
          cr = cl + this.mpos.d;
          stop = true;
        }
        if (cr > this.mpos.mr) {
          cr = this.mpos.mr;
          cl = cr - this.mpos.d;
          stop = true;
        }
      } else if (this.action === "left") {
        for (let i in this.scenesTime) {
          if (Math.abs(cl - this.scenesTime[i]) < 0.1) {
            cl = this.scenesTime[i];
            break;
          }
        }
        cr = this.mpos.r;
        if (cl < this.mpos.ml) {
          cl = this.mpos.ml;
          stop = true;
        } else if (cl > this.mpos.mr) {
          cl = this.mpos.mr;
          stop = true;
        }
      } else if (this.action === "right") {
        for (let i in this.scenesTime) {
          if (Math.abs(cr - this.scenesTime[i]) < 0.1) {
            cr = this.scenesTime[i];
            break;
          }
        }
        cl = this.mpos.l;
        if (cr < this.mpos.ml) {
          cr = this.mpos.ml;
          stop = true;
        } else if (cr > this.mpos.mr) {
          cr = this.mpos.mr;
          stop = true;
        }
      }
      this.subtitles[this.indexS].start = cl;
      this.subtitles[this.indexS].end = cr;
      this.subtitles[this.indexS].dura = cr - cl;
      // this.nowTime = cl;
      return stop;
    },
    limitTime(dire) {
      // 时间快拖动触发的滚动循环方法
      if (this.limitTimeMove) return;
      this.limitTimeMove = true;
      let start = null,
        startNode = this.scrollToTime(dire === 1),
        step = null,
        dt = 0;
      step = timestamp => {
        if (!start) start = timestamp;
        // 除以1000 为一倍速， 这里的200为正常时间的5倍
        dt = (dire * (timestamp - start)) / 200 + startNode;
        if (dt <= 0) {
          this.nowTime = 0;
          this.scrollLeft = 0;
          this.$refs.timelineBody.scrollLeft = 0;
          window.cancelAnimationFrame(this.limitTimeFrame);
        } else if (dt >= this.totalTime) {
          this.nowTime = this.totalTime;
          this.scrollLeft = this.scrollWidth - this.visibleWidth;
          this.$refs.timelineBody.scrollLeft = this.scrollLeft;
          window.cancelAnimationFrame(this.limitTimeFrame);
        } else {
          // 让时间光标在显示区0.1的区域，不至于贴近极限位置
          this.nowTime = dt - dire * 0.1;
          this.timeToScroll(dt, dire === 1);
          this.limitTimeFrame = window.requestAnimationFrame(step);
        }
      };

      this.limitTimeFrame = window.requestAnimationFrame(step);
    },
    cancelLimitTime(disx) {
      // 关闭时间拖块触发的滚动循环
      if (this.limitTimeMove) {
        window.cancelAnimationFrame(this.limitTimeFrame);
        this.limitTimeMove = false;
        if (disx) {
          // 回到正常拖动后的mousedown初始值更改
          this.mpos.x = disx;
          this.mpos.nowTime =
            (disx - this.limitLeft) / this.secondWidth + this.scrollToTime();
        }
      }
    },
    scrollToTime(dire) {
      // 通过滚动位置确定时间
      this.scrollLeft = this.$refs.timelineBody.scrollLeft;
      if (dire) {
        // 右极限时间
        return (this.scrollLeft + this.visibleWidth - 10) / this.secondWidth;
      } else {
        // 左极限
        let dx = (this.scrollLeft - 10) / this.secondWidth;
        return dx < 0 ? 0 : dx;
      }
    },
    timeToScroll(t, dire) {
      // 根据时间计算滚动条的位置
      let sl = 0;
      if (dire) {
        // 右极限
        sl = t * this.secondWidth + 10 - this.visibleWidth;
      } else {
        // 左极限
        sl = t * this.secondWidth + 10;
      }
      this.scrollLeft = sl;
      this.$refs.timelineBody.scrollLeft = sl;
    },
    limitSubtitle(dire, mpos) {
      // 字幕块拖动触发的滚动循环方法
      if (this.limitSubtitleMove) return;
      this.limitSubtitleMove = true;

      let start = null,
        startNode =
          dire === 1 ? this.limitRight - mpos.x : this.limitLeft - mpos.x,
        step = null,
        change = 0,
        cl = mpos.l,
        cr = mpos.r,
        ds = 0,
        stop = false;

      step = timestamp => {
        if (!start) start = timestamp;
        ds = ((dire * (timestamp - start)) / 200) * this.secondWidth;
        change = (ds + startNode) / this.secondWidth;
        cl = mpos.l + change;
        cr = mpos.r + change;
        stop = this.subtitleBoxChange(cl, cr);
        if (stop) {
          window.cancelAnimationFrame(this.limitSubtitleFrame);
          return;
        }
        mpos.change = change;
        ds = ds + mpos.scroll;
        this.scrollLeft = ds;
        this.$refs.timelineBody.scrollLeft = ds;
        this.limitSubtitleFrame = window.requestAnimationFrame(step);
      };

      this.limitSubtitleFrame = window.requestAnimationFrame(step);
    },
    cancellimitSubtitle(disx) {
      // 关闭字幕拖块触发的滚动循环
      if (this.limitSubtitleMove) {
        window.cancelAnimationFrame(this.limitSubtitleFrame);
        this.limitSubtitleMove = false;
        if (disx) {
          // 回到正常拖动后的mousedown初始值更改
          let disxT, cl, cr;
          this.scrollLeft = this.$refs.timelineBody.scrollLeft;
          this.mpos.scroll = this.scrollLeft;
          // 算出鼠标回归正常后的位置对应的时间
          disxT =
            (this.scrollLeft + disx - this.limitLeft - 10) / this.secondWidth;
          // 计算出鼠标回归后的字幕块的位置和大小
          if (this.action === "move") {
            // 可能字幕快很大，不能简单的定位在中心位置，而是用开始计算好的距离start位置的差值dx
            cl = disxT - this.mpos.dx;
            cr = cl + this.mpos.d;
          } else if (this.action === "left") {
            // 直接定位到边缘区域（left区域本身就很小）
            cl = disxT;
          } else if (this.action === "right") {
            cr = disxT;
          }
          // 判断对应的位置是否有超过极限（也就是条件判断条件后的字幕快位置，大小）
          this.subtitleBoxChange(cl, cr);
          // 修改mousedown初始化的字幕信息（对应这次鼠标回归的位置）
          this.mpos.l = this.subtitles[this.indexS].start;
          this.mpos.r = this.subtitles[this.indexS].end;
          this.mpos.d = this.subtitles[this.indexS].dura;
          // 然后根据字幕快的位置大小计算出鼠标应该在什么位置
          if (this.action === "move") {
            this.mpos.x =
              (this.mpos.l + this.mpos.dx) * this.secondWidth -
              this.scrollLeft +
              this.limitLeft +
              10;
          } else if (this.action === "left") {
            this.mpos.x =
              this.mpos.l * this.secondWidth -
              this.scrollLeft +
              this.limitLeft +
              10;
          } else if (this.action === "right") {
            this.mpos.x =
              this.mpos.r * this.secondWidth -
              this.scrollLeft +
              this.limitLeft +
              10;
          }
          // 以上逻辑终结为  鼠标 -> 字幕快（应该） -> 字幕快（实际） -> 鼠标
        }
      }
    },
    scrollEvent(e) {
      // 滚动事件
      this.scrollLeft = e.target.scrollLeft;
      this.handleXLeft =
        (this.scrollLeft * (this.visibleWidth - 20)) / this.scrollWidth;
    },
    addSubtitle() {
      // 添加字幕
      let sub = {}; // 添加字幕的对象
      let index = -1; // 插入的位置
      let limit = 0; // 字幕end位置最小值
      let limitL = 0; // 字幕的end所存在的范围最值
      sub.startTime = +this.nowTime.toFixed(3);
      limit = sub.startTime + 0.2;
      // 循环字幕数组，找出出入的位置
      for (let i in this.subtitles) {
        let max = 0;
        let s = this.subtitles[i];
        if (sub.startTime < s.start) {
          index = +i;
          break;
        } else if (sub.startTime < s.end) {
          this.$message({
            showClose: true,
            message: '当前时间的位置已经有一个字幕了',
            type: 'warning'
          });
          return false;
        }
        index = +i + 1;
      }

      // 计算end的范围最值
      if (this.subtitles[index]) {
        limitL = +this.subtitles[index].start.toFixed(3);
      } else {
        limitL = this.totalTime;
      }

      if (limit <= limitL) {
        // 可以放下的情况
        if (limitL - sub.startTime > 1) {
          sub.endTime = sub.startTime + 1;
        } else {
          sub.endTime = limitL;
        }

        let obj = {
          start: sub.startTime,
          end: sub.endTime,
          dura: sub.endTime - sub.startTime,
          text: "添加字幕内容"
        };
        if (index > -1 && index < this.subtitles.length) {
          this.subtitles.splice(index, 0, obj);
        } else {
          index = this.subtitles.length
          this.subtitles.push(obj);
        }
        this.$store.commit("subtitle/addSubtitles", {
          index: index,
          subtitle: sub
        });
        this.$store.commit("subtitle/setSubIndex", index);
        //this.subtitleArr[i]
        this.calcSubtitles();
        //console.log(this.subtitleObj, this.subtitleArr, this.subtitles);
        this.$bus.emit("insert_subtitle_undo", {
          type: "addSubtitles_time",
          data: {
            index: index,
            data: JSON.stringify(this.subtitleArr[index])
          }
        });
        return true;
      } else {
        // 时间不够放下一个字幕了
        this.$message({
          showClose: true,
          message: '时间不够放下一个字幕了',
          type: 'warning'
        });
        return false;
      }
    },
    delSubtitle() {
      // 删除字幕
      if (this.subIndex > -1) {
        this.$store.commit("subtitle/delSubtitles");
        this.subtitles.splice(this.subIndex, 1);
      }
    },
    preview(e) {
      // 预览按钮
      let start = null,
        startNode = 0,
        step = null;

      if (!this.isPlay) {
        if (this.nowTime >= this.totalTime) {
          // 时间在最后的时候从头开始
          this.scrollLeft = 0;
          this.$refs.timelineBody.scrollLeft = 0;
          this.nowTime = 0;
        }
        startNode = this.nowTime;
        this.initScencePlay()
      }
      this.isPlay = !this.isPlay;

      this.$bus.emit("timeline_play_all", {
        isPlay: this.isPlay,
        time: this.nowTime
      });
      this.oldFrame = 0;

      step = timestamp => {
        if (!this.isPlay) {
          window.cancelAnimationFrame(this.playFrame);
          return;
        }
        let progress = 0;
        if (!start) start = timestamp;
        progress = (timestamp - start) / 1000;
        this.nowTime = progress + startNode;

        if (this.nowTime < this.totalTime) {
          // 此处的20为了可以让滚动条滚到最开始和最后（同时让光标距离右极限0.1s）
          if (
            this.nowTime * this.secondWidth + 20 >
            this.scrollLeft + this.visibleWidth
          ) {
            this.scrollLeft =
              this.nowTime * this.secondWidth - this.visibleWidth + 20;
            this.$refs.timelineBody.scrollLeft = this.scrollLeft;
          }
          this.playFrame = window.requestAnimationFrame(step);
        } else {
          window.cancelAnimationFrame(this.playFrame);
          this.nowTime = this.totalTime;
          this.isPlay = false;
          this.$bus.emit("timeline_play_all", {
            isPlay: this.isPlay,
            time: this.nowTime
          });
        }
      };

      this.playFrame = window.requestAnimationFrame(step);
    },
    stopPlay() {
      // 关闭预览
      this.isPlay && this.preview();
    }
  },
  directives: {
    dragSubtitle(el, binding, vnode) {
      let _this = vnode.context,
        mousemove = null,
        mouseup = null,
        disx = 0,
        dataset = null;

      mousemove = e => {
        e.preventDefault();

        _this.mouseMove(e.pageX);
      };

      mouseup = e => {
        e.preventDefault();
        document.removeEventListener("mousemove", mousemove);
        document.removeEventListener("mouseup", mouseup);

        _this.mouseUp(e.pageX);
      };

      el.onmousedown = e => {
        _this.$bus.emit("subtitle_input_text_stop");
        e.preventDefault();

        document.addEventListener("mousemove", mousemove);
        document.addEventListener("mouseup", mouseup);

        _this.mouseDown(e.target.dataset, e.pageX, e);
      };

      el.oncontextmenu = e => {
        return false;
      };
    }
  },
  filters: {
    formatTime(duration) {
      if (duration <= 0) return "00:00";
      if (!duration) return "--:--";
      var min = ~~(duration / 60);
      min = (min + "").length === 1 ? "0" + min : min;
      var sec = Math.floor(duration % 60);
      sec = (sec + "").length === 1 ? "0" + sec : sec;
      min = min || "00";
      sec = sec || "00";
      return min + ":" + sec;
    }
  },
  beforeDestroy() {
    this.$refs.timelineBody.onmousedown = null;
    this.$refs.timelineBody.onscroll = null;
    window.removeEventListener("mousedown", this.stopPlay);
    window.removeEventListener("resize", this.initStyle);
    this.$bus.off("pickUpSubtitle")
    this.$bus.off("subtitle_undoRodo_execute")
    this.$bus.off("subtitle_keycode_del")
    this.$bus.off("subtitle_keycode_space")
    this.$bus.off("subtitle_panel_del")
    this.$bus.off("subtitle_updateItemText_vue")
    this.$bus.off("subtitle_fromJson")
  }
};
</script>

<style lang="scss" scoped>
.timeline-subtitle {
  position: absolute;
  bottom: 0;
  width: calc(100% - 246px);
  height: 180px;
  background: #f0f0f8;
}
.timeline-subtitle-button {
  display: flex;
  height: 66px;
  // padding: 0 30px 0 150px;
  justify-content: center;
  align-items: center;
}
.play-subtitle {
  position: relative;
  width: 42px;
  height: 42px;
  margin: 0 10px 0 26px;
  cursor: pointer;
  outline: none;

  i {
    display: block;
    width: 40px;
    height: 40px;
  }
  i.play {
    background: url("../../../static/svg/play.svg") no-repeat center;
    &:hover,
    &:active {
      background: url("../../../static/svg/play-active.svg") no-repeat center;
    }
  }

  i.pause {
    background: url("../../../static/svg/pause.svg") no-repeat center;
    &:hover,
    &:active {
      background: url("../../../static/svg/pause-active.svg") no-repeat center;
    }
  }
}
.play-time-show {
  display: flex;
  width: 80px;
  color: #424f61;
  font-size: 14px;
}
.add-subtitle {
  width: 88px;
  height: 34px;
  line-height: 34px;
  border-radius: 4px;
  font-size: 14px;
  font-weight: bold;
  background-color: #5778fb;
  color: #fff;
  cursor: pointer;
  &:hover {
    background-color: #7d95f5;
  }
}
.timeline-subtitle-content {
  position: relative;
  top: 0;
  left: 0;
  width: 90%;
  margin: 0 3% 0 7%;
}

.timeline-body {
  position: relative;
  top: 0;
  left: 0;
  width: 100%;
  height: 138px;
  overflow-x: scroll;
  overflow-y: hidden;
}
.slider-timeline {
  position: absolute;
  top: 13px;
  z-index: 20;

  .slider-handle {
    position: relative;
    top: 8px;
    left: -2.4px;
    width: 26px;
    height: 16px;
    box-shadow: none;
    cursor: pointer;
    touch-action: pan-x;
    filter: none !important;
    -webkit-clip-path: polygon(
      100% 0,
      100% 25%,
      55% 100%,
      45% 100%,
      0 25%,
      0 0
    );
    clip-path: polygon(100% 0, 100% 25%, 55% 100%, 45% 100%, 0 25%, 0 0);
    background: url("./../../assets/handle.svg") no-repeat;
    background-size: cover;
    z-index: 10;
  }
  .slider-line {
    height: 28px;
    width: 1px;
    position: absolute;
    top: 20px;
    left: 10px;
    background-color: #474261;
  }
}
.axis-timeline-mask {
  position: absolute;
  left: 0;
  top: 20px;
  z-index: 10;
  height: 10px;
  cursor: pointer;
}
.axis-timeover-mask {
  position: absolute;
  left: 0;
  top: 20px;
  z-index: 15;
  height: 10px;
  opacity: 0.6;
  background-color: #f0f0f8;
}
.axis-timeline {
  position: relative;
  left: 0;
  top: 0;
  display: flex;
  justify-content: flex-start;
  margin-top: 20px;
  font-size: 12px;
  color: #8f8ba9;
  border-bottom: 1px solid #babdd6;
}
.axis-second {
  position: relative;
  width: 100px;
  height: 8px;
  border-left: 1px solid #babdd6;

  .second-time {
    position: relative;
    left: -50%;
    top: -200%;
  }
  .second-line {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: flex-end;

    div {
      width: 10%;
      height: 4px;
      border-right: 1px solid #babdd6;
    }
    .middle-line {
      height: 6px;
    }
  }
}
.axis-first,
.axis-last {
  position: relative;
  top: 1px;
  left: 0;
  width: 10px;
  height: 8px;
  background: #f0f0f8;
}
.axis-last {
  border-left: 1px solid #babdd6;

  span {
    position: absolute;
    top: -200%;
    left: -200%;
  }
}
.time-over-color {
  color: #d4d6e6;
}

.subtitle-box {
  position: relative;
  left: 10px;
  top: 0;
  height: 30px;
  background-color: #e5e6f0;
  border-radius: 4px;
}
.total-time-width {
  height: 30px;
  background-color: #d4d6e6;
  border-radius: 4px;
}
.subtitle-box-content {
  position: absolute;
  top: 0;
  height: 30px;
  background-color: #9da0ba;
  border-radius: 6px;
  overflow: hidden;

  &.active,
  &:hover {
    background-color: #8f92af;
  }
}
.subtitle-move {
  width: 100%;
  height: 100%;
  padding: 0 6px;
  line-height: 30px;
  color: #fff;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  cursor: pointer;
}
.drag-left,
.drag-right {
  position: absolute;
  height: 30px;
  top: 0;
  width: 5px;
  opacity: 0;
  cursor: ew-resize;
}
.drag-left {
  left: 0;
}
.drag-right {
  right: 0;
}
.scenes-time-line {
  position: absolute;
  top: 0;
  height: 30px;
  width: 1px;
  background-color: #e5e6f0;

  &::before {
    content: "场景分割线";
    display: none;
    position: absolute;
    top: 31px;
    left: -31px;
    width: 62px;
    height: 12px;
    line-height: 12px;
    font-size: 12px;
    color: #aaaaaa;
  }

  &:hover::before {
    display: block;
  }
}

.scroll-left-line {
  position: absolute;
  top: 75px;
  left: 10px;
  width: calc(100% - 20px);
  height: 1px;
  background-color: #d4d6e7;
}

.scroll-left-handle {
  position: relative;
  top: -3px;
  left: 0;
  width: 100px;
  height: 7px;
  border-radius: 3.5px;
  background-color: #bdbfcf;
  cursor: pointer;
}

.timeline-body-title {
  position: absolute;
  font-size: 14px;
  color: #8f8ba9;
  left: -42px;
  top: 36px;
}
</style>



// WEBPACK FOOTER //
// src/components/subtitle/timeline.vue